<template>
<span>
    <v-row class="ma-0 container-side-padding mt-5 mt-sm-15">
        <v-breadcrumbs class="pa-0 diia-nav-breadcrumbs" :items="[]">
        <template v-slot:divider>
            <span color="black">|</span>
        </template>
        </v-breadcrumbs>
    </v-row>
    <v-row class="ma-0 mt-3 container-side-padding">
        <v-col class="ma-0 pa-0" cols="12" xs="12" sm="12" md="12" lg="7">
            <h1 class="diia-nav-menu-h1-header-breadcrumbs">Повідомлення про визначення відповідальної особи</h1>
        </v-col>
    </v-row>
    <div style="height: 80px;" class="d-none d-sm-block"></div>
    <div style="height: 30px;" class="d-block d-sm-none"></div>

    <v-row class="ma-0 mt-3 container-side-padding">
      <v-col class="pa-0" cols="12" :lg="9" order="3" order-sm="3" order-md="3" order-lg="1">
        <template v-if="stepper_page_number == 1">
          <v-row class="ma-0 top-margin-bottom-header-reponsive">
            <v-container fluid class="pa-0 ma-0">
              <span style="opacity: 0.5;">Крок 1 із 2</span>
              <h2 style="font-size: 38px; font-weight: normal; line-height: 40px; letter-spacing: -0.02em; margin-bottom: 60px;">Заповніть обов'язкові поля</h2>
              <v-alert
                  v-if="showAlert"
                  type="error"
                  class="mt-3">{{ alertMessage }}
              </v-alert>
              <v-form ref="form" v-model="valid">
                <h3 class="mb-0 mt-0 mb-5 diia-h3-header">Дані про юридичну особу</h3>
                <v-row class="ma-0">
                    <v-col cols="12" md="8" class="pa-0">
                        <v-text-field
                            v-model="new_statement_org_name"
                            :rules="textRules"
                            label="Найменування юридичної особи"
                            hint="Повне найменування органу державної влади/органу місцевого самоврядування/суб’єкта господарювання згідно з Єдиним державним реєстром юридичних осіб, фізичних осіб-підприємців та громадських формувань."
                            clearable
                            required
                            class="diia-v-input"
                        ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="4" class="pl-md-4 pa-0">
                        <v-text-field
                            v-model="new_statement_org_edrpou"
                            :rules="edrpouFieldRules"
                            label="Код ЄДРПОУ"
                            :counter="8"
                            clearable
                            required
                            class="diia-v-input"
                            @input="onEdrpouInput"
                        ></v-text-field>
                    </v-col>
                </v-row>
                <h3 class="mb-0 mt-10 mb-5 diia-h3-header">Дані про керівника/уповноваженої особи</h3>
                <v-row class="ma-0">
                  <v-col cols="12" md="6" class="pa-0">
                    <v-text-field
                        v-model="new_statement_org_head_name"
                        :rules="nameRules"
                        label="Власне ім’я, ПРІЗВИЩЕ керівника/ уповноваженої особи органу державної влади/органу місцевого самоврядування/суб’єкта господарювання на вчинення правочинів від імені Учасника"
                        hint="Власне ім’я, ПРІЗВИЩЕ керівника/ уповноваженої особи органу державної влади/органу місцевого самоврядування/суб’єкта господарювання на вчинення правочинів від імені Учасника. Приклад: Володимир ШЕВЧЕНКО"
                        clearable
                        required
                        class="diia-v-input"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6" class="pl-md-4 pa-0">
                    <v-text-field
                        v-model="new_statement_org_head_role"
                        :rules="textRules"
                        label="Посада"
                        clearable
                        required
                        class="diia-v-input"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row class="ma-0">
                  <v-col cols="12" md="8" class="pa-0">
                    <v-text-field
                        v-model="new_statement_org_head_document"
                        :rules="textRules"
                        label="Діє на підставі"
                        hint="Назва документу на підставі якого діє керівник/ уповноважена особа органу державної влади/органу місцевого самоврядування/суб’єкта господарювання на вчинення правочинів від імені Учасника."
                        clearable
                        required
                        class="diia-v-input"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="4" class="pl-md-4 pa-0">
                    <v-file-input
                        prepend-icon
                        label="Документ, що підтверджує повноваження"
                        v-model="head_document_file"
                        class="diia-v-input"
                        accept=".pdf,.docx"
                    >
                    </v-file-input>
                  </v-col>
                </v-row>

                
                <v-card elevation="0">
                  <h3 class="mb-0 mt-10 mb-5 diia-h3-header">
                      Відповідальні особи
                  </h3>
                  <DiiaMessageBox :text="$config.responsible_person_table_banner"/>
                  <v-col cols="12" class="pl-0">
                      <v-data-table
                          locale="uk-UA"
                          :headers="responsibles_list_headers"
                          :items="responsibles_list"
                          disable-pagination
                          disable-sort
                          disable-filtering
                          hide-default-footer
                          mobile-breakpoint="1"
                          no-data-text="Відповідальні особи відсутні"
                          loading-text="Виконується запит..."
                          class="elevation-0 pa-0 data-table-detail-design"
                      >
                          <template v-slot:item.actions="{ item }">
                              <v-icon
                                  @click="onDeleteResponsiblePerson(item)"
                              >
                                  mdi-close
                              </v-icon>
                          </template>
                      </v-data-table>
                  </v-col>
                  <v-form ref="responsible_form" v-model="responsibles_form_valid" fluid lazy>
                    <v-row class="ma-0">
                        <v-col cols="12" md="8" class="pa-0">
                            <v-text-field
                                v-model="new_statement_org_applicant_resp_person_full_name"
                                :rules="nameRules"
                                label="Власне ім'я, ПРІЗВИЩЕ відповідальної особи"
                                hint="Приклад: Володимир ШЕВЧЕНКО"
                                clearable
                                required
                                class="diia-v-input"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="4" class="pl-md-4 pa-0">
                            <v-text-field
                                v-model="new_statement_org_applicant_resp_person_rnokpp"
                                :rules="rnokppRules"
                                label="РНОКПП відповідальної особи"
                                hint="РНОКПП користувача або серія (за наявності) та номер паспорта (для користувачів, які через свої релігійні переконання відмовляються від прийняття РНОКПП та офіційно повідомили про це відповідний контролюючий орган і мають відмітку у паспорті). Використовується для аутентифікації відповідальної особи через особистий кабінет, та інші сервіси системи."
                                clearable
                                required
                                class="diia-v-input"
                            ></v-text-field>
                        </v-col>
                        </v-row>
                        <v-row class="ma-0">
                        <v-col cols="12" md="6" class="pa-0">
                            <v-text-field
                                v-model="new_statement_org_applicant_resp_person_phone"
                                :rules="phoneRules"
                                label="Контактний телефон відповідальної особи"
                                hint="Формат: +380xxxxxxxxx. У випадку декількох номерів, перелічити через кому."
                                clearable
                                required
                                class="diia-v-input"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="6" class="pl-md-4 pa-0">
                            <v-text-field
                                v-model="new_statement_org_applicant_resp_person_email"
                                :rules="emailRules"
                                label="Електронна пошта (e-mail) відповідальної особи"
                                hint="У випадку декількох адрес, перелічити через кому."
                                clearable
                                required
                                class="diia-v-input"
                            ></v-text-field>
                        </v-col>
                    </v-row>

                    <v-card-actions class="justify-start ma-0 pa-0 mt-3">
                      <v-btn
                          elevation="0"
                          class="diia-button-style-3"
                          @click="addResponsiblePersonToList"
                      >
                          Додати
                      </v-btn>
                    </v-card-actions>
                  </v-form>
                </v-card>
              </v-form>
              <!-- </v-container> -->
            <br>
            <div style="margin: 0px;" class="mt-10">
              <p><b>Учасник підтверджує:</b></p>
              <v-checkbox
                  v-model="new_statement_agree_data_process"
                  label="Згоду на обробку персональних даних, викладених у цьому Повідомлені відповідно до Закону України «Про захист персональних даних»."
                  required
                  :off-icon="'mdi-checkbox-blank-outline'" :on-icon="'mdi-checkbox-outline'" :ripple="false"
                  color="black"
              ></v-checkbox>
              <v-checkbox
                  v-model="new_statement_agree_admin_manipulation"
                  label="Це Повідомлення є підставою для здійснення державним підприємством «ДІЯ», яке є адміністратором системи Трембіта відповідно до Положення про систему електронної взаємодії державних електронних інформаційних ресурсів, затвердженого постановою Кабінету Міністрів від 8 вересня 2016 р. № 606, організаційних заходів відповідно до Регламенту системи електронної взаємодії державних електронних інформаційних ресурсів."
                  required
                  :off-icon="'mdi-checkbox-blank-outline'" :on-icon="'mdi-checkbox-outline'" :ripple="false"
                  color="black"
              ></v-checkbox>
            </div>
            <v-card-actions class="justify-space-between d-block d-md-flex">
              <div style="margin: 10px 0px; width: 600px">
                <small>
                  <b>Примітка:</b>
                  <br>Повідомлення має бути згенеровано в електронній формі через дану Форму.
                  <br>Згенероване Повідомлення може бути подане до Держателя одним із таких способів:
                  <br><span style="margin-left: 30px">1.	В електронній формі через Форму подання Повідомлень, попередньо підписавши за допомогою кваліфікованого електронного підпису (керівника/уповноваженої суб’єкта владних повноважень/суб’єкта господарювання на вчинення відповідних правочинів).</span>
                  <br><span style="margin-left: 30px">2.	Із урахуванням вимог законодавства з питань документування управлінської діяльності, попередньо завантаживши та підписавши Повідомлення, надіслати яке можна, зокрема, засобами СЕВ ОВВ або поштовим зв’язком.</span>
                </small>
              </div>
              <v-btn
                  color="primary"
                  elevation="0"
                  class="diia-button-style-3"
                  @click="onGeneratePDF"
                  :disabled="!valid || responsibles_list.length === 0 || !!edrpouError || showAlert || !new_statement_agree_data_process || !new_statement_agree_admin_manipulation"
              >
                Перейти до перегляду
              </v-btn>
          </v-card-actions>
        </v-container>
      </v-row>
    </template>
    <template v-if="stepper_page_number == 2">
      <v-container class="ma-0 pa-0" fluid>
        <span style="opacity: 0.5;">Крок 2 із 2</span>
        <h2 style="font-size: 38px; font-weight: normal; line-height: 40px; letter-spacing: -0.02em; margin-bottom: 60px;">Перегляд та підпис</h2>
        <v-row class="ma-0 pa-0">
            <embed
                :src="pdf_view_url"
                width="100%"
                height="1100px"
                type="application/pdf"
            />
        </v-row>
        <v-row class="ma-0 pa-0">
          <v-card elevation="0" class="mr-3 pa-0">
            <v-card-title>
              <small>Перегляд та підпис</small>
            </v-card-title>
            <v-card-text>
              <v-timeline align-top dense class="pa-0">
                <v-timeline-item small class="text-left">
                  <v-card elevation="0">
                    Перевірте правильність сформованого Повідомлення. Якщо дані
                    внесено неправильно, поверніться до попереднього кроку
                    та виправте помилки.
                    <v-card-actions class="justify-end">
                      <v-btn
                          class="diia-button-style-3"
                          elevation="0"
                          @click="stepper_page_number = 1;"
                      >
                          Редагувати
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-timeline-item>
                <template v-if="true">
                  <v-timeline-item small class="text-left">
                    <v-card elevation="0">
                    
                    Підпишіть Повідомлення за допомогою кваліфікованого електронного підпису (керівника/уповноваженої особи суб’єкта владних повноважень/суб’єкта господарювання на вчинення відповідних правочинів).
                    <br><br>
                    Або завантажте згенероване Повідомлення, підпишіть у керівника/уповноваженої особи суб’єкта владних повноважень/суб’єкта господарювання на вчинення відповідних правочинів та надішліть Держателю системи Трембіта, засобами СЕВ ОВВ або поштовим зв’язком.
                    <br><br>
                    <v-card-actions class="justify-end">
                        <v-btn
                            class="diia-button-style-3"
                            elevation="0"
                            @click="sign_dialog = !sign_dialog"
                        >
                          Підписати Повідомлення онлайн
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-timeline-item>
                </template>
                <template
                    v-if="
                    !(
                      (isEmptyObject(signature_file) &&
                        !sign_verify_successful)
                    )
                  "
                >
                  <v-timeline-item small class="text-left">
                    <v-card elevation="0">
                      Відправте підписане Повідомлення Держателю системи Трембіта.
                      <v-card-actions class="justify-end">
                        <v-btn
                            class="diia-button-style-3"
                            elevation="0"
                            @click="onSendSignature"
                            :disabled="
                            (isEmptyObject(signature_file) &&
                              !sign_verify_successful)
                          "
                        >
                          Відправити Повідомлення
                        </v-btn>
                        <!-- <div id="sign-widget-parent"></div> -->
                      </v-card-actions>
                    </v-card>
                  </v-timeline-item>
                </template>

              </v-timeline>
            </v-card-text>
          </v-card>
        </v-row>
      </v-container>
    </template>
    <template v-if="stepper_page_number == 3">
      <v-container fluid class="pa-0">
        <div class="mb-20 pb-20">
          <h2 style="font-size: 38px; font-weight: normal; line-height: 40px; letter-spacing: -0.02em; margin-bottom: 60px;">Дякуємо!</h2>
          <div style="font-size: 18px; line-height: 42px;">
              Повідомлення подане на розгляд Держателю системи «Трембіта»
              <br/>
              <a :href="generated_data.statement_link" target="_blank"> Завантажити Повідомлення </a>
              <br/>
              <a :href="generated_data.statement_link + '.p7s'" target="_blank"> Завантажити підпис </a>
          </div>
        </div>
        <div style="height: 80px; display: block; width: 1px;">
        </div>
      </v-container>
    </template>
    <v-dialog v-model="sign_dialog" max-width="600" width="600" persistent>
      <v-card max-width="600" width="600">
        <v-overlay absolute :value="sign_loading_bar" opacity="0.8">
          <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <v-card-text>
          <div
              id="sign-widget-parent"
              style="width: 100%; height: 510px"
          ></div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
          <v-btn @click="sign_dialog = !sign_dialog"> Закрити </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <SignInfoDialog
        v-if="showSignInfoDialog"
        :key="signInfoDialogKey"
        :sign_data="sign_verify_result"
        :successful="sign_verify_successful"
    />
    <v-overlay :value="overlay">
      <v-progress-circular
          indeterminate
          absolute
          size="48"
      ></v-progress-circular>
    </v-overlay>
  </v-col>
</v-row>
</span>
</template>
<script type="text/javascript" src="../js/eusign.js"></script>
<script>
/* eslint-disable */
// import pdf from "vue-pdf";
import axios from "axios";
// import EditResponsiblePerson from "./EditResponsiblePerson";
// import DeleteResponsiblePerson from "./DeleteResponsiblePerson";
import SignInfoDialog from "./SignInfoDialog";
import {EndUser} from "../js/eusign";

//=============================================================================
/*
    Ідентифікатор батківського елементу для відображення iframe,
    який завантажує сторінку SignWidget
*/
const SIGN_WIDGET_PARENT_ID = "sign-widget-parent";
/*
    Ідентифікатор iframe, який завантажує сторінку SignWidget
*/
const SIGN_WIDGET_ID = "sign-widget";
/*
    URI з адресою за якою розташована сторінка SignWidget
*/
const SIGN_WIDGET_URI = "https://id.gov.ua/sign-widget/v20220527/";

//=============================================================================

// euSign = EndUser();

export default {
  components: {
    // pdf,
    // EditResponsiblePerson,
    SignInfoDialog,
    // DeleteResponsiblePerson,
  },
  props: ["request_data"],
  data: () => ({
    // pdf_view_url:
    //   "http://10.0.43.141:8000/media/generated-statements/62587faa-f854-444c-af9f-e4df114076e6.pdf",
    edrpouError: "",
    debounceTimeout: null,
    alertMessage: "",
    sign_dialog: false,
    sign_loading_bar: false,
    nameRules: [
      (v) => !!v || "Поле обов'язкове",
      (v) => v.split(" ").length >= 2 || "Не коректно заповнене Власне ім'я та ПРІЗВИЩЕ",
    ],
    edrpouRules: [
      (v) => !!v || "Поле обов'язкове",
      (v) => v.length == 8 || "Код ЄДРПОУ складається з 8 цифр",
      (v) => /^\d+$/.test(v) || "Не коректно заповнений ЄДРПОУ",
    ],
    rnokppRules: [
      (v) => !!v || "Поле обов'язкове",
      (v) => /([0-9]{10}|[АБВГДЕЄЖЗИІКЛМНОПРСТУФХЦЧШЩЮЯ]{2}[0-9]{6}|[0-9]{9})/.test(v) || "Не коректно заповнений РНОКПП",
      (v) => v.length <= 10 || "Розмір перевищує 10 символів",
    ],
    passportOrganRules: [
      (v) => !!v || "Поле обов'язкове",
      (v) => v.length == 4 || "Поле має містити 4 цифри",
      (v) => /^\d+$/.test(v) || "Поле не відповідає формату",
    ],
    textRules: [
      (v) => !!v || "Поле обов'язкове",
      (v) => v.length > 1 || "Довжина поля занадто маленька",
    ],
    phoneRules: [
      (v) => !!v || "Поле обов'язкове",
      (v) => {
        let arr = v.split(',')
        for (let i = 0; i < arr.length; i++) {
          if (!(/^[+]?[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{6}$/im.test(arr[i].trim()))) {
            return "Не корректний номер телефону"
          }
        }
        return true
      }
    ],
    emailRules: [
      (v) => !!v || "Поле обов'язкове",
      (v) => {
        let arr = v.split(',')
        for (let i = 0; i < arr.length; i++) {
          if (!(/.+@.+/.test(arr[i].trim()))) {
            return "Не корректна e-mail адреса"
          }
        }
        return true
      },
    ],
    valid: false,
    showResponsiblePersonModal: false,
    showSignInfoDialog: false,
    responsible_person_list: [],
    pdf_view_url: "",
    overlay: false,
    new_statement_agree_data_process: false,
    new_statement_agree_admin_manipulation: false,
    stepper_page_number: 1,

    responsibles_list_headers: [
      {
        text: 'Власне ім\'я та прізвище',
        value: 'responsible_first_last_name',
        align: 'start',
        class: 'data-table-detail-header',
      },
      {
        text: 'Код РНОКПП',
        value: 'responsible_rnokpp',
        align: 'start',
        class: 'data-table-detail-header',
        width: '150px',
      },
      {
        text: 'Контактний телефон',
        value: 'responsible_phone',
        align: 'start',
        class: 'data-table-detail-header',
        width: '300px',
      },
      {
        text: 'Електронна пошта',
        value: 'responsible_email',
        align: 'start',
        class: 'data-table-detail-header',
        width: '300px',
      },
      {
        text: '',
        value: 'actions',
        align: 'start',
        class: 'data-table-detail-header',
        width: '50px',
      },
    ],
    responsibles_list: [],

    responsibles_form_valid: false,
    showAlert: false,

    new_statement_org_head_name: "",
    new_statement_org_head_role: "",
    new_statement_org_head_document: "",

    new_statement_org_edrpou: "",
    new_statement_org_name: "",

    new_statement_org_applicant_resp_person_full_name: "",
    new_statement_org_applicant_resp_person_phone: "",
    new_statement_org_applicant_resp_person_email: "",
    new_statement_org_applicant_resp_person_rnokpp: "",


    responsiblePersonUpdatedData: false,
    head_document_file: null,
    signature_file: {},
    generated_data: {},
    sign_file_link: "",
    sign_verify_result: {},
    sign_verify_successful: false,
    savedSign: "",
    // sign_ready_to_be_sent: false,

    signInfoDialogKey: 25242323232,
    editResponsiblePersonKey: 43453325232,
  }),
  computed: {
    edrpouFieldRules() {
      return [
        ...this.edrpouRules,
        () => !this.edrpouError || this.edrpouError,
      ];
    },
  },
  watch: {
    stepper_page_number(newVal, oldVal) {
      if (newVal === 1 && oldVal === 2) {
        this.$nextTick(() => {
          if (this.$refs.responsible_form) {
            this.$refs.responsible_form.resetValidation();
            this.responsibles_form_valid = false;
          }
          if (this.$refs.form) {
            this.$refs.form.resetValidation();
          }
          this.$nextTick(() => {
            if (this.$refs.form) {
              this.$refs.form.validate();
            }
          });
        });
      }
    },
    sign_dialog(dialog) {
      if (dialog) {
        if (document.getElementById(SIGN_WIDGET_PARENT_ID)) {
          document.getElementById(SIGN_WIDGET_PARENT_ID).innerHTML = "";
        }
        const self = this;
        setTimeout(() => {
          self.euSign = new EndUser(
              SIGN_WIDGET_PARENT_ID,
              SIGN_WIDGET_ID,
              SIGN_WIDGET_URI,
              EndUser.FormType.ReadPKey
          );
          setTimeout(() => {
            self.euSign
                .ReadPrivateKey()
                .then((d = null) => {
                  self.onSign();
                })
                .catch((e) => {
                  alert(
                      "Виникла помилка при зчитуванні ос. ключа. " +
                      "Опис помилки: " +
                      (e.message || e)
                  );
                });
          }, 3000);
        }, 1000);
      }
    },
  },
  methods: {
    testDataGeneration() {
      this.new_statement_org_head_name = "Василій БАТЬКОВИЧ";
      this.new_statement_org_head_role = "Директор";
      this.new_statement_org_head_document = "Статуту ООН про безправність людини";

      this.new_statement_org_edrpou = "30855996";
      this.new_statement_org_name = "ДП ДІР";

      this.responsibles_list = [{
        responsible_first_last_name: "Щастя",
        responsible_rnokpp: "1231123132",
        responsible_phone: "Телефон",
        responsible_email: "Емеил",
      }, {
        responsible_first_last_name: "Щастя",
        responsible_rnokpp: "1231123132",
        responsible_phone: "Телефон",
        responsible_email: "Емеил",
      }];
    },

    addResponsiblePersonToList() {
      this.$refs.responsible_form.validate();

      if (this.responsibles_form_valid) {
        this.responsibles_list.push({
          responsible_first_last_name: this.new_statement_org_applicant_resp_person_full_name,
          responsible_rnokpp: this.new_statement_org_applicant_resp_person_rnokpp,
          responsible_phone: this.new_statement_org_applicant_resp_person_phone,
          responsible_email: this.new_statement_org_applicant_resp_person_email,
        });

        this.new_statement_org_applicant_resp_person_full_name = "";
        this.new_statement_org_applicant_resp_person_rnokpp = "";
        this.new_statement_org_applicant_resp_person_phone = "";
        this.new_statement_org_applicant_resp_person_email = "";

        this.$refs.responsible_form.resetValidation();
      }
    },

    async validateEdrpouExists(edrpou) {
      try {
        const response = await axios.get(
            `${this.$config.backend_url}/api/v1/directory/organization/?search_member_code=${edrpou}`
        );
        return response.data.count > 0;
      } catch (error) {
        console.error("Помилка перевірки ЄДРПОУ:", error);
        return false;
      }
    },
    async onEdrpouInput() {
      const edrpou = this.new_statement_org_edrpou;

      this.edrpouError = "";
      this.showAlert = false;

      if (!edrpou) {
        this.edrpouError = "";
        this.alertMessage = "";
        this.showAlert = false;
        return;
      }

      if (edrpou.length !== 8 || !/^\d+$/.test(edrpou)) {
        this.edrpouError = "Код ЄДРПОУ повинен складатися з 8 цифр";
        return;
      }

      if (this.debounceTimeout) {
        clearTimeout(this.debounceTimeout);
      }

      this.debounceTimeout = setTimeout(async () => {
        try {
          const exists = await this.validateEdrpouExists(edrpou);

          if (!exists) {
            this.edrpouError = "Цей код ЄДРПОУ вже зареєстрований у системі";
            this.alertMessage = "Організація із вказаним кодом ЄДРПОУ не зареєстрована у системі.";
            this.showAlert = true;

            this.clearFieldTimeout = setTimeout(() => {
              this.new_statement_org_edrpou = "";
            }, 5000);
          }
        } catch (error) {
          console.error("Помилка при перевірці ЄДРПОУ:", error);
          this.edrpouError = "Сталася помилка при перевірці коду ЄДРПОУ";
        }
      }, 500);
    },

    async getFile(url) {
      const blob_file = await fetch(url).then(function (t) {
        return t.blob().then((b) => {
          return b;
        });
      });
      return blob_file;
    },
    async getBase64(url) {
      const file = await this.getFile(url);
      const to_base64 = new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
      }).catch((e) => {
        // debugger;
        console.log(e);
      });
      // debugger;
      const base64_data = await to_base64;
      return base64_data.replace(/^data:.+;base64,/, "");
    },
    async onSign() {
      let self = this;
      const doc_base_64 = await self.getBase64(self.pdf_view_url);
      self.sign_loading_bar = true;
      let byteCharacters = atob(doc_base_64);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const data = new Uint8Array(byteNumbers);
      let external = true;
      let asBase64String = true;
      let signAlgo = EndUser.SignAlgo.DSTU4145WithGOST34311;
      let signType = EndUser.SignType.CAdES_X_Long;
      const sign_data = await self.euSign
          .SignData(data, external, asBase64String, signAlgo, null, signType)
          .then(function (sign) {
            return sign;
          })
          .then((sign) => {
            return sign;
          })
          .catch((e) => {
            alert(
                "Виникла помилка при підписі даних. " +
                "Опис помилки: " +
                (e.message || e)
            );
          });
      this.savedSign = sign_data;
      this.finishApproveECP()
          .then(() => {
            this.sign_loading_bar = false;
            this.sign_dialog = false;
            // this.sign_ready_to_be_sent = true;
          })
          .catch((error) => {
            console.log(error);
          });
    },
    finishApproveECP() {
      // var bodyFormData = new FormData();
      // bodyFormData.append("content", this.savedSign);
      let bodyFormData = {
        sign: this.savedSign,
      };

      return axios({
        method: "put",
        url:
            this.$config.backend_url +
            "/api/v1/statements/sevdeir_new_responsible_register/sign_encoded/" +
            this.generated_data.id +
            "/",
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
        },
        data: bodyFormData,
      })
          .then((response) => {
            this.sign_verify_result = response.data;
            this.sign_verify_successful = true;
            this.signInfoDialogKey += 1;
            this.showSignInfoDialog = true;
          })
          .catch((error) => {
            this.sign_verify_result = error.response.data;
            this.sign_verify_successful = false;
            this.signInfoDialogKey += 1;
            this.showSignInfoDialog = true;

            console.log(error);
            console.log(error.response);
            console.log(error.response.status);
          });
      // .finally(() => {
      //   this.overlay = false;
      // });
    },

    isEmptyObject(obj) {
      if (!obj) return true;
      if (obj && Object.keys(obj).length === 0 && obj.constructor === Object)
        return true;
      return false;
    },

    handleUpdateResponsiblePerson(resp_data) {
      let data = {
        name: resp_data.responsible_person_name,
        phone: resp_data.responsible_person_phone,
        email: resp_data.responsible_person_email,
        drfo: resp_data.responsible_person_drfo,
        position: resp_data.responsible_person_position,
      };

      if (!resp_data.same_org) {
        data.org_edrpou = resp_data.responsible_person_organization_edrpou;
        data.org_name = resp_data.responsible_person_organization_name;
        data.org_phone = resp_data.responsible_person_organization_phone;
        data.org_email = resp_data.responsible_person_organization_email;
        data.org_address = resp_data.responsible_person_organization_address;
        data.inherited = false;
      } else {
        data.org_edrpou = "";
        data.org_name = "";
        data.org_phone = "";
        data.org_email = "";
        data.org_address = "";
        data.inherited = true;
      }
      if (this.responsiblePersonUpdatedData) {
        this.responsible_person_list = this.arrayRemove(
            this.responsible_person_list,
            this.responsiblePersonUpdatedData
        );
      }
      this.responsible_person_list.push(data);
    },

    onGeneratePDF() {
      if (!this.$refs.form || !this.$refs.form.validate()) {
        return;
      }
      if (this.responsibles_list.length === 0) {
        return;
      }
      if (this.edrpouError || this.showAlert) {
        return;
      }
      if (!this.new_statement_agree_data_process || !this.new_statement_agree_admin_manipulation) {
        return;
      }

      let request_person_list = [];

      let data = {
        head_person_full_name: this.new_statement_org_head_name,
        head_person_position: this.new_statement_org_head_role,
        head_person_document: this.new_statement_org_head_document,

        organization_edrpou: this.new_statement_org_edrpou,
        organization_name: this.new_statement_org_name,

        responsibles_set: this.responsibles_list,
      };

      this.overlay = true;
      axios({
        method: "post",
        url:
            this.$config.backend_url +
            "/api/v1/statements/sevdeir_new_responsible_register/generate/",
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
        },
        data: data,
      })
          .then((response) => {
            this.generated_data = response.data;

            if (this.head_document_file) {
              var bodyFormData = new FormData();
              bodyFormData.append("head_person_document_file", this.head_document_file);

              axios({
                method: "post",
                url:
                    this.$config.backend_url +
                    "/api/v1/statements/sevdeir_new_responsible_register/document_file/" +
                    this.generated_data.id +
                    "/",
                headers: {
                  "Content-Type": "multipart/form-data;charset=UTF-8",
                },
                data: bodyFormData,
              })
                  .then((response) => {
                  })
                  .catch((error) => {
                    console.log(error);
                    console.log(error.response);
                    console.log(error.response.status);
                  });
            }

            this.pdf_view_url =
                this.$config.backend_url + response.data.statement_file;
            this.stepper_page_number = 2;
          })
          .catch((error) => {
            console.log(error);
            console.log(error.response);
            console.log(error.response.status);
          })
          .finally(() => {
            this.overlay = false;
          });
    },
    onSendSignature(event) {
      event.preventDefault();
      this.generated_data.signature_file = "https://google.com";
      this.onSendStatementApply();
    },
    onSendStatementApply() {
      this.overlay = true;
      axios({
        method: "put",
        url:
            this.$config.backend_url +
            "/api/v1/statements/sevdeir_new_responsible_register/apply/" +
            this.generated_data.id +
            "/",
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
        },
      })
          .then((response) => {
            this.generated_data.statement_link =
                this.$config.backend_url + this.generated_data.statement_file;
            this.generated_data.signature_link =
                this.$config.backend_url + this.generated_data.signature_file;

            this.stepper_page_number += 1;
          })
          .catch((error) => {
            console.log(error);
            console.log(error.response);
            console.log(error.response.status);
          })
          .finally(() => {
            this.overlay = false;
          });
    },
    arrayRemove(arr, value) {
      return arr.filter(function (ele) {
        return ele != value;
      });
    },
    onDeleteResponsiblePerson(item) {
      this.responsibles_list = this.arrayRemove(this.responsibles_list, item);
    },
    removeResponsiblePersonFromList(item) {
      this.onDeleteResponsiblePerson(item);
    },
    onEditResponsiblePerson(item) {
      this.responsiblePersonUpdatedData = item;
      this.editResponsiblePersonKey++;
      this.showResponsiblePersonModal = true;
    },
  },
};
</script>